import {validateField, submitFields, clearFields} from './helpers/form'
import {
  FETCH_PRODUCTION_ACTIVATE_DATA_SUCCESS,
  VALIDATE_PRODUCTION_ACTIVATE_FIELD,
  SUBMIT_PRODUCTION_ACTIVATE_FIELDS,
  CLEAR_PRODUCTION_ACTIVATE_FIELDS
} from '../../../actions/pages/production-page'

export function productionActivate(
  state = {
    valid: false,
    fields: [
      {
        name: 'LocalizedTitle',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Title',
          required: true
        }
      },
      {
        name: 'Description',
        value: '',
        type: 'text',
        errors: [],
        rules: {
          title: 'Description',
          required: true
        }
      },
      {
        name: 'Urgent',
        value: false,
        type: 'checkbox',
        rules: {
          title: 'Urgent'
        }
      },
      {
        name: 'PosterImageFile',
        value: '',
        errors: [],
        rules: {
          title: 'Poster',
          required: true
        }
      },
      {
        name: 'PosterUrl',
        value: '',
        errors: [],
        rules: {
          title: ''
        }
      }
    ]
  },
  action
) {
  switch (action.type) {
    case FETCH_PRODUCTION_ACTIVATE_DATA_SUCCESS: {
      let posterExist = false;
      let fields = state.fields.map((field) => {
        let newValue;
        Object.entries(action.data).forEach(([key, value]) => {
          if (field.name === key){
            newValue = value;
            return;
          }
        })

        if (newValue !== undefined) {
          if (field.name === 'PosterUrl' && newValue != null) {
            posterExist = true;
          }

          return {
            ...field,
            value: newValue,
            errors: []
          }
        }

        return field;
      })

      // set poster as not required if poster already exist
      let fieldsWithPoster = fields.map((field) => {
        if (field.name === 'PosterImageFile' && posterExist) {         
          return {
            ...field,
            rules: {
              title: ''
            }
          }
        }

        return field;
      })

      return Object.assign({}, state, {
        valid: true,
        fields: Array.from(fieldsWithPoster)
      })
    }

    case VALIDATE_PRODUCTION_ACTIVATE_FIELD:
      return validateField(state, action);
    
    case SUBMIT_PRODUCTION_ACTIVATE_FIELDS:
      return submitFields(state, action);

    case CLEAR_PRODUCTION_ACTIVATE_FIELDS:
      return clearFields(state);

    default:
      return state
  }
}
